import { WebSocketConnectionManager } from '../wsClient'
import type { TradingDataModel } from '@trading/core'
import type { IncomingMessagePayload } from '../wsClient'
import { PublickConnectionChannels } from '../wsClient'

export type SubscribeToChannelResult = {
  unsubscribe: undefined | (() => void),
  removeHandler: undefined | (() => void)
}

export class TradingDataWS {
  private wsChannel = PublickConnectionChannels['KLINES']
  private unsubscribeHandler: (() => void) = () => { throw new Error("Method not initialized."); }
  private unsubscribeChannel: (() => void) = () => { throw new Error("Method not initialized."); }

  constructor(private wsManager: WebSocketConnectionManager) {}

  public unsubscribeToChannel(): void {
    this.unsubscribeHandler()
    this.unsubscribeChannel()
  }

  async subscribeToChannel(instrument: string, interval: string, cb: (order: TradingDataModel) => void): Promise<undefined | SubscribeToChannelResult> {
    const connection = await this.wsManager.getConnection('public')
    const unsubscribe = connection.subscribeToChannelMessages(this.wsChannel, {
      symbol: instrument,
      interval: interval
    })
    const removeHandler = connection.addChannelHandler(this.wsChannel, (data: IncomingMessagePayload<TradingDataModel>) => {
      if (data.type === 'update') {
        cb(data.data)
      }
    })
    return { unsubscribe, removeHandler }
  }
}
